import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
//import Breadcrumbs
import Breadcrumbs from "../../components/Common/Breadcrumb";
import DataTableHelper from "../../helpers/tables/DataTableHelper";
import Columns from "./Columns";
import AddUpdModal from "./AddUpdModal";
import { getCompanies } from "../../helpers/backend_helper";
import { DestroyAlertHelper, Alert } from "../../helpers/alerts/alertHelper";
import { Container } from "reactstrap";
import ButtonHelper from "../../helpers/ButtonHelper";

const initCompany = {
  id: "",
  company_name: "",
  name: "",
  email: "",
  password: "",
  password_confirm: "",
  phone: "",
  local_phone: "",
};

const Company = () => {
  const [pending, setPending] = useState(false);
  const [modal, setModal] = useState({ show: false, update: false });
  const [filters, setFilters] = useState({
    page: 1,
    perPage: 20,
    search: "",
    orderBy: "id",
    order: "asc",
  });
  const [items, setItems] = useState([]);
  const [dataPag, setDataPag] = useState({});
  const [companyBase, setCompanyBase] = useState(initCompany);
  const [company, setCompany] = useState(companyBase);
  const dispatch = useDispatch();

  const fetchCompanies = useCallback((filters) => {
    let params = { params: filters };
    setPending(true);
    getCompanies(params).then((response) => {
      setItems(response.data);
      setDataPag(response.meta);
      setPending(false);
    });
  }, []);

  const refreshCompanies = () => fetchCompanies(filters);

  useEffect(() => {
    fetchCompanies(filters);
  }, [filters]);

  const addUpd = (row = false) => {
    if (row.id) {
      setCompany({
        ...row,
        company_name: row.name,
      });
      setModal({ ...modal, show: true, update: true });
    } else {
      setCompany(initCompany);

      setModal({ ...modal, show: true, update: false });
    }
  };

  const columns = Columns(addUpd);
  document.title = "Company | Sistema de logística";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="col-12">
            <DataTableHelper
              tittle="Empresas"
              columns={columns}
              items={items}
              pending={pending}
              getCompanies={getCompanies}
              config={dataPag}
              filters={filters}
              setFilters={setFilters}
            >
              <div
                className="ms-auto float-end ms-2"
                style={{ maxWidth: "120px" }}
              >
                <button
                  className="btn btn-sm btn-primary"
                  onClick={() => addUpd(initCompany)}
                >
                  <i className="fas fa-solid fa-plus"></i> Agregar
                </button>
              </div>
            </DataTableHelper>
          </div>
        </Container>
        {modal.show && (
          <AddUpdModal
            modal={modal}
            setModal={setModal}
            company={company}
            refreshCompanies={refreshCompanies}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default Company;
